export const ACTIONS = {
  COPY: 'copy',
  DELETE: 'delete',
  CUT: 'cut',
  CODE: 'code',
  BOLD: 'bold',
  LINK: 'link',
  ITALIC: 'italic',
  STRIKE: 'strike',
  HEADINGS: 'headings',
  SUBSCRIPT: 'subscript',
  UNDERLINE: 'underline',
  TEXT_ALIGN: 'textAlign',
  TEXT_COLOR: 'textColor',
  SUPERSCRIPT: 'superscript',
  AI_FIX_GRAMMER: 'aiFixGrammar',
  AI_TRANSLATION: 'aiTranslation',
  AI_IMPROVE_WRITING: 'aiImproveWriting',
  NODE_CONVERTER: 'nodeConverter',
  PARAGRAPH: 'paragraph',
  IMAGE: 'image',
  VIDEO: 'video',
  BULLET_LIST: 'bulletList',
  ORDERED_LIST: 'orderedList',
  TASK_LIST: 'taskList',
  CODE_BLOCK: 'codeblock',
  BLOCKQUOTE: 'blockquote',
  HORIZONTAL_RULE: 'horizontalRule',
  TABLE: 'table',
  DATE: 'date',
  INLINE_COMMENT: 'inlineComment',
  TEXT_HIGHLIGHT: 'textHighlight',
  CLEAR_FORMATTING: 'clearFormatting',
  ACCORDION: 'accordion',
};

export const editorConfig = {
  features: {
    markdown: true,
    dropCursor: true,
    hardBreak: true,
    nodeFormatting: true,
    trailingNode: true,
    history: true,

    // Miscellaneous Features
    dropCursor: true,
    hardBreak: true,
    nodeFormatting: true,
    trailingNode: true,
    undoRedo: true,
    history: true,
    placeholder: true,
    find: true,
    findExtension: true,
    dateNodeExtension: true,
    emojiEnabled: true,

    // AI Features
    nodeConverter: {
      enabled: true,
      toolbar: { enabled: true, position: 'main', order: 0, showDivider: true },
    },
    paragraph: {
      enabled: true,
      toolbar: { enabled: true },
    },
    headings: {
      enabled: true,
      toolbar: { enabled: false, position: 'main', order: 1, showDivider: true },
      shortcuts: { enabled: true, order: 2 },
    },
    link: {
      enabled: true,
      toolbar: { enabled: true, position: 'main', order: 2 },
      shortcuts: { enabled: false, order: 6 },
    },
    code: {
      enabled: true,
      toolbar: { enabled: true, position: 'main', order: 3, showDivider: true },
    },
    bold: {
      enabled: true,
      toolbar: { enabled: true, position: 'main', order: 4 },
    },
    italic: {
      enabled: true,
      toolbar: { enabled: true, position: 'main', order: 5 },
    },
    underline: {
      enabled: true,
      toolbar: { enabled: true, position: 'main', order: 6 },
    },
    textColor: {
      enabled: true,
      toolbar: { enabled: true, position: 'main', order: 7 },
    },
    ai: {
      improveWriting: { enabled: true, toolbar: { enabled: true, position: 'main', order: 8 } },
      fixGrammar: { enabled: true, toolbar: { enabled: true, position: 'main', order: 9 } },
      translation: { enabled: true, toolbar: { enabled: true, position: 'main', order: 10, showDivider: true } },
    },
    strike: {
      enabled: true,
      toolbar: { enabled: true, position: 'more', order: 11 },
    },
    subscript: {
      enabled: true,
      toolbar: { enabled: true, position: 'more', order: 12 },
    },
    superscript: {
      enabled: true,
      toolbar: { enabled: true, position: 'more', order: 13 },
    },
    textAlign: {
      enabled: true,
      toolbar: { enabled: true, position: 'more', order: 14 },
    },

    // List Elements
    bulletList: {
      enabled: true,
      toolbar: { enabled: true },
      shortcuts: { enabled: true, order: 3 },
    },
    orderedList: {
      enabled: true,
      toolbar: { enabled: true },
      shortcuts: { enabled: true, order: 4 },
    },
    taskList: {
      enabled: true,
      toolbar: { enabled: true },
      shortcuts: { enabled: true, order: 5 },
    },

    // Media Features
    image: {
      enabled: true,
      shortcuts: { enabled: true, order: 13 },
    },
    video: {
      enabled: true,
      shortcuts: { enabled: true, order: 14 },
    },
    iframe: {
      enabled: true,
      shortcuts: { enabled: false, order: 15 },
    },

    // Formatting & Insertions
    blockquote: {
      enabled: true,
      toolbar: { enabled: true },
      shortcuts: { enabled: true, order: 6 },
    },
    horizontalRule: {
      enabled: true,
      shortcuts: { enabled: true, order: 5 },
    },

    // Media & Embeds
    image: {
      enabled: true,
      shortcuts: { enabled: true, order: 9 },
    },
    video: {
      enabled: true,
      shortcuts: { enabled: true, order: 10 },
    },
    iframe: {
      enabled: true,
      shortcuts: { enabled: false, order: 9 },
    },
    mediaUpload: true,

    // Code Blocks & Formatting
    codeblock: {
      enabled: true,
      toolbar: { enabled: true },
      shortcuts: { enabled: true, order: 11 },
    },

    date: {
      enabled: true,
      toolbar: { enabled: false },
      shortcuts: { enabled: true, order: 12 },
    },

    // Table Features
    table: {
      enabled: true,
      shortcuts: { enabled: true, order: 7 },
    },
    // inline comment feature
    inlineComment: {
      enabled: true,
      toolbar: { enabled: true, position: 'main', order: 1 },
    },

    divider: true,
    tableInsert: true,
    tableNavigation: true,
    tableNavigationExtension: true,

    // panels
    calloutPanel: {
      enabled: true,
      types: [
        { title: 'Info Panel', description: 'Highlight information in colored panel.', value: 'info' },
        { title: 'Danger Panel', description: 'Call out errors in a colored panel.', value: 'danger' },
        { title: 'Warning Panel', description: 'Add a warning in colored panel.', value: 'warning' },
        { title: 'Success Panel', description: 'Add tips in colored panel.', value: 'success' },
      ],
      shortcuts: { enabled: true, order: 8 },
    },

    textHighlight: {
      enabled: true,
      toolbar: { enabled: true, order: 7, position: 'main', showDivider: true },
    },

    clearFormatting: {
      enabled: true,
      toolbar: { enabled: true, order: 11, position: 'main' },
    },

    accordion: {
      enabled: true,
      shortcuts: { enabled: true, order: 9 },
    },
  },
};
